unit settings.usercopyrights;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.Controls, WEBLib.ExtCtrls, Vcl.StdCtrls,
  WEBLib.StdCtrls, Data.DB, WEBLib.DB, XData.Web.JsonDataset, XData.Web.Dataset,
  WEBLib.DBCtrls;

type
  TfrmUserCopyRights = class(TForm)
    WebPanel1: TPanel;
    WebPanel2: TPanel;
    WebLabel1: TLabel;
    qUsers: TXDataWebDataSet;
    dsUsers: TDataSource;
    wdblUsers: TDBLookupComboBox;
    WebLabel8: TLabel;
    WebPanel3: TPanel;
    btnClose: TButton;
    btnCopyRights: TButton;
    qUsersSLNCODE: TStringField;
    qUsersEMAIL: TStringField;
    qUsersSLNNAME: TStringField;
    qUsersSIGNATURE: TBlobField;
    qUsersPASSWORD: TStringField;
    qUsersACCESSRIGHTS: TBlobField;
    qUsersEMAILPASSWORD: TStringField;
    qUsersSITES: TIntegerField;
    qUsersUSERID: TIntegerField;
    qUsersREPCODE: TStringField;
    qUserslastlogindatetime: TDateTimeField;
    qUsersloginipaddress: TStringField;
    qUserslogedin: TStringField;
    qUsersloginhostname: TStringField;
    qUsersloginwebip: TStringField;
    qUserscellnumber: TStringField;
    qUsersmailclient: TIntegerField;
    qUserssmsonly: TStringField;
    qUserspasswordlastchanged: TDateTimeField;
    qUserssmsdieselerrors: TStringField;
    qUserssuspended: TIntegerField;
    procedure btnCloseClick(Sender: TObject);
    procedure btnCopyRightsClick(Sender: TObject);
  private
    { Private declarations }
  public
    { Public declarations }
    sUser, sAccessRights : String;
    btnCopySelected : Boolean;
  protected procedure LoadDFMValues; override; end;

var
  frmUserCopyRights: TfrmUserCopyRights;

implementation

{$R *.dfm}

uses
  stfmssystem.connection;

procedure TfrmUserCopyRights.btnCloseClick(Sender: TObject);
begin
 btnCopySelected := False;
 Close;
end;

procedure TfrmUserCopyRights.btnCopyRightsClick(Sender: TObject);
var sThisUser : String;
begin
 sThisUser := TrimRight(qUsers.FieldByName('SLNCODE').AsString);
 sAccessRights := qUsers.FieldByName('accessrights').AsString;
 btnCopySelected := True;
end;

procedure TfrmUserCopyRights.LoadDFMValues;
begin
  inherited LoadDFMValues;

  WebPanel1 := TPanel.Create(Self);
  WebLabel8 := TLabel.Create(Self);
  WebPanel2 := TPanel.Create(Self);
  WebLabel1 := TLabel.Create(Self);
  wdblUsers := TDBLookupComboBox.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  btnClose := TButton.Create(Self);
  btnCopyRights := TButton.Create(Self);
  qUsers := TXDataWebDataSet.Create(Self);
  qUsersSLNCODE := TStringField.Create(Self);
  qUsersEMAIL := TStringField.Create(Self);
  qUsersSLNNAME := TStringField.Create(Self);
  qUsersSIGNATURE := TBlobField.Create(Self);
  qUsersPASSWORD := TStringField.Create(Self);
  qUsersACCESSRIGHTS := TBlobField.Create(Self);
  qUsersEMAILPASSWORD := TStringField.Create(Self);
  qUsersSITES := TIntegerField.Create(Self);
  qUsersUSERID := TIntegerField.Create(Self);
  qUsersREPCODE := TStringField.Create(Self);
  qUserslastlogindatetime := TDateTimeField.Create(Self);
  qUsersloginipaddress := TStringField.Create(Self);
  qUserslogedin := TStringField.Create(Self);
  qUsersloginhostname := TStringField.Create(Self);
  qUsersloginwebip := TStringField.Create(Self);
  qUserscellnumber := TStringField.Create(Self);
  qUsersmailclient := TIntegerField.Create(Self);
  qUserssmsonly := TStringField.Create(Self);
  qUserspasswordlastchanged := TDateTimeField.Create(Self);
  qUserssmsdieselerrors := TStringField.Create(Self);
  qUserssuspended := TIntegerField.Create(Self);
  dsUsers := TDataSource.Create(Self);

  WebPanel1.BeforeLoadDFMValues;
  WebLabel8.BeforeLoadDFMValues;
  WebPanel2.BeforeLoadDFMValues;
  WebLabel1.BeforeLoadDFMValues;
  wdblUsers.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  btnClose.BeforeLoadDFMValues;
  btnCopyRights.BeforeLoadDFMValues;
  qUsers.BeforeLoadDFMValues;
  qUsersSLNCODE.BeforeLoadDFMValues;
  qUsersEMAIL.BeforeLoadDFMValues;
  qUsersSLNNAME.BeforeLoadDFMValues;
  qUsersSIGNATURE.BeforeLoadDFMValues;
  qUsersPASSWORD.BeforeLoadDFMValues;
  qUsersACCESSRIGHTS.BeforeLoadDFMValues;
  qUsersEMAILPASSWORD.BeforeLoadDFMValues;
  qUsersSITES.BeforeLoadDFMValues;
  qUsersUSERID.BeforeLoadDFMValues;
  qUsersREPCODE.BeforeLoadDFMValues;
  qUserslastlogindatetime.BeforeLoadDFMValues;
  qUsersloginipaddress.BeforeLoadDFMValues;
  qUserslogedin.BeforeLoadDFMValues;
  qUsersloginhostname.BeforeLoadDFMValues;
  qUsersloginwebip.BeforeLoadDFMValues;
  qUserscellnumber.BeforeLoadDFMValues;
  qUsersmailclient.BeforeLoadDFMValues;
  qUserssmsonly.BeforeLoadDFMValues;
  qUserspasswordlastchanged.BeforeLoadDFMValues;
  qUserssmsdieselerrors.BeforeLoadDFMValues;
  qUserssuspended.BeforeLoadDFMValues;
  dsUsers.BeforeLoadDFMValues;
  try
    Name := 'frmUserCopyRights';
    Width := 431;
    Height := 214;
    CSSLibrary := cssBootstrap;
    ElementFont := efCSS;
    Font.Charset := DEFAULT_CHARSET;
    Font.Color := clWindowText;
    Font.Height := -15;
    Font.Name := 'Tahoma';
    Font.Style := [];
    ParentFont := False;
    WebPanel1.SetParentComponent(Self);
    WebPanel1.Name := 'WebPanel1';
    WebPanel1.Left := 0;
    WebPanel1.Top := 0;
    WebPanel1.Width := 431;
    WebPanel1.Height := 214;
    WebPanel1.ElementClassName := 'card';
    WebPanel1.HeightPercent := 100.000000000000000000;
    WebPanel1.WidthPercent := 100.000000000000000000;
    WebPanel1.Align := alClient;
    WebPanel1.BorderColor := clSilver;
    WebPanel1.BorderStyle := bsSingle;
    WebPanel1.ElementBodyClassName := 'card-body';
    WebPanel1.ElementFont := efCSS;
    WebLabel8.SetParentComponent(WebPanel1);
    WebLabel8.Name := 'WebLabel8';
    WebLabel8.Left := 15;
    WebLabel8.Top := 80;
    WebLabel8.Width := 70;
    WebLabel8.Height := 16;
    WebLabel8.Caption := 'Select User:';
    WebLabel8.Font.Charset := DEFAULT_CHARSET;
    WebLabel8.Font.Color := clWindowText;
    WebLabel8.Font.Height := -13;
    WebLabel8.Font.Name := 'Tahoma';
    WebLabel8.Font.Style := [];
    WebLabel8.HeightStyle := ssAuto;
    WebLabel8.HeightPercent := 100.000000000000000000;
    WebLabel8.ParentFont := False;
    WebLabel8.WidthPercent := 100.000000000000000000;
    WebPanel2.SetParentComponent(WebPanel1);
    WebPanel2.Name := 'WebPanel2';
    WebPanel2.Left := 0;
    WebPanel2.Top := 0;
    WebPanel2.Width := 431;
    WebPanel2.Height := 33;
    WebPanel2.ElementClassName := 'card';
    WebPanel2.HeightPercent := 100.000000000000000000;
    WebPanel2.WidthPercent := 100.000000000000000000;
    WebPanel2.Align := alTop;
    WebPanel2.BorderColor := clSilver;
    WebPanel2.BorderStyle := bsNone;
    WebPanel2.ChildOrder := 1;
    WebPanel2.ElementBodyClassName := 'card-body';
    WebPanel2.ElementFont := efCSS;
    WebPanel2.Font.Charset := DEFAULT_CHARSET;
    WebPanel2.Font.Color := clWindowText;
    WebPanel2.Font.Height := -13;
    WebPanel2.Font.Name := 'Tahoma';
    WebPanel2.Font.Style := [];
    WebPanel2.ParentFont := False;
    WebPanel2.ShowCaption := False;
    WebLabel1.SetParentComponent(WebPanel2);
    WebLabel1.Name := 'WebLabel1';
    WebLabel1.Left := 0;
    WebLabel1.Top := 0;
    WebLabel1.Width := 431;
    WebLabel1.Height := 33;
    WebLabel1.Align := alClient;
    WebLabel1.Alignment := taCenter;
    WebLabel1.Caption := 'Copy User Access Rights';
    WebLabel1.ElementFont := efCSS;
    WebLabel1.HeightStyle := ssAuto;
    WebLabel1.HeightPercent := 100.000000000000000000;
    WebLabel1.WidthPercent := 100.000000000000000000;
    wdblUsers.SetParentComponent(WebPanel1);
    wdblUsers.Name := 'wdblUsers';
    wdblUsers.Left := 103;
    wdblUsers.Top := 77;
    wdblUsers.Width := 315;
    wdblUsers.Height := 22;
    wdblUsers.Font.Charset := DEFAULT_CHARSET;
    wdblUsers.Font.Color := clWindowText;
    wdblUsers.Font.Height := -13;
    wdblUsers.Font.Name := 'Tahoma';
    wdblUsers.Font.Style := [];
    wdblUsers.HeightPercent := 100.000000000000000000;
    wdblUsers.ParentFont := False;
    wdblUsers.WidthPercent := 100.000000000000000000;
    wdblUsers.KeyField := 'SLNCODE';
    wdblUsers.ListField := 'SLNNAME';
    wdblUsers.ListSource := dsUsers;
    WebPanel3.SetParentComponent(WebPanel1);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 149;
    WebPanel3.Width := 431;
    WebPanel3.Height := 65;
    WebPanel3.ElementClassName := 'card';
    WebPanel3.HeightPercent := 100.000000000000000000;
    WebPanel3.WidthPercent := 100.000000000000000000;
    WebPanel3.Align := alBottom;
    WebPanel3.BorderColor := clSilver;
    WebPanel3.BorderStyle := bsNone;
    WebPanel3.ChildOrder := 1;
    WebPanel3.ElementBodyClassName := 'card-body';
    WebPanel3.ElementFont := efCSS;
    WebPanel3.ShowCaption := False;
    btnClose.SetParentComponent(WebPanel3);
    btnClose.Name := 'btnClose';
    btnClose.Left := 268;
    btnClose.Top := 6;
    btnClose.Width := 150;
    btnClose.Height := 49;
    btnClose.Color := 3937500;
    btnClose.Caption := 'Close';
    btnClose.Font.Charset := DEFAULT_CHARSET;
    btnClose.Font.Color := clWhite;
    btnClose.Font.Height := -13;
    btnClose.Font.Name := 'Tahoma';
    btnClose.Font.Style := [];
    btnClose.HeightStyle := ssAuto;
    btnClose.HeightPercent := 100.000000000000000000;
    btnClose.ParentFont := False;
    btnClose.WidthPercent := 100.000000000000000000;
    SetEvent(btnClose, Self, 'OnClick', 'btnCloseClick');
    btnCopyRights.SetParentComponent(WebPanel3);
    btnCopyRights.Name := 'btnCopyRights';
    btnCopyRights.Left := 12;
    btnCopyRights.Top := 6;
    btnCopyRights.Width := 150;
    btnCopyRights.Height := 49;
    btnCopyRights.Color := 11186720;
    btnCopyRights.Caption := 'Copy Access Rights';
    btnCopyRights.ChildOrder := 1;
    btnCopyRights.Font.Charset := DEFAULT_CHARSET;
    btnCopyRights.Font.Color := clWhite;
    btnCopyRights.Font.Height := -13;
    btnCopyRights.Font.Name := 'Tahoma';
    btnCopyRights.Font.Style := [];
    btnCopyRights.HeightStyle := ssAuto;
    btnCopyRights.HeightPercent := 100.000000000000000000;
    btnCopyRights.ParentFont := False;
    btnCopyRights.WidthPercent := 100.000000000000000000;
    SetEvent(btnCopyRights, Self, 'OnClick', 'btnCopyRightsClick');
    qUsers.SetParentComponent(Self);
    qUsers.Name := 'qUsers';
    qUsers.EntitySetName := 'workemail';
    qUsers.Connection := dmData.dbConnect;
    qUsers.QueryString := '$filter=suspended eq '#39'N'#39' & order SLNNAME';
    qUsers.Left := 38;
    qUsers.Top := 34;
    qUsersSLNCODE.SetParentComponent(qUsers);
    qUsersSLNCODE.Name := 'qUsersSLNCODE';
    qUsersSLNCODE.FieldName := 'SLNCODE';
    qUsersSLNCODE.Required := True;
    qUsersSLNCODE.Size := 10;
    qUsersEMAIL.SetParentComponent(qUsers);
    qUsersEMAIL.Name := 'qUsersEMAIL';
    qUsersEMAIL.FieldName := 'EMAIL';
    qUsersEMAIL.Required := True;
    qUsersEMAIL.Size := 100;
    qUsersSLNNAME.SetParentComponent(qUsers);
    qUsersSLNNAME.Name := 'qUsersSLNNAME';
    qUsersSLNNAME.FieldName := 'SLNNAME';
    qUsersSLNNAME.Size := 50;
    qUsersSIGNATURE.SetParentComponent(qUsers);
    qUsersSIGNATURE.Name := 'qUsersSIGNATURE';
    qUsersSIGNATURE.FieldName := 'SIGNATURE';
    qUsersPASSWORD.SetParentComponent(qUsers);
    qUsersPASSWORD.Name := 'qUsersPASSWORD';
    qUsersPASSWORD.FieldName := 'PASSWORD';
    qUsersPASSWORD.Size := 50;
    qUsersACCESSRIGHTS.SetParentComponent(qUsers);
    qUsersACCESSRIGHTS.Name := 'qUsersACCESSRIGHTS';
    qUsersACCESSRIGHTS.FieldName := 'ACCESSRIGHTS';
    qUsersEMAILPASSWORD.SetParentComponent(qUsers);
    qUsersEMAILPASSWORD.Name := 'qUsersEMAILPASSWORD';
    qUsersEMAILPASSWORD.FieldName := 'EMAILPASSWORD';
    qUsersEMAILPASSWORD.Size := 25;
    qUsersSITES.SetParentComponent(qUsers);
    qUsersSITES.Name := 'qUsersSITES';
    qUsersSITES.FieldName := 'SITES';
    qUsersUSERID.SetParentComponent(qUsers);
    qUsersUSERID.Name := 'qUsersUSERID';
    qUsersUSERID.FieldName := 'USERID';
    qUsersREPCODE.SetParentComponent(qUsers);
    qUsersREPCODE.Name := 'qUsersREPCODE';
    qUsersREPCODE.FieldName := 'REPCODE';
    qUsersREPCODE.Size := 10;
    qUserslastlogindatetime.SetParentComponent(qUsers);
    qUserslastlogindatetime.Name := 'qUserslastlogindatetime';
    qUserslastlogindatetime.FieldName := 'lastlogindatetime';
    qUsersloginipaddress.SetParentComponent(qUsers);
    qUsersloginipaddress.Name := 'qUsersloginipaddress';
    qUsersloginipaddress.FieldName := 'loginipaddress';
    qUsersloginipaddress.Size := 45;
    qUserslogedin.SetParentComponent(qUsers);
    qUserslogedin.Name := 'qUserslogedin';
    qUserslogedin.FieldName := 'logedin';
    qUserslogedin.Size := 1;
    qUsersloginhostname.SetParentComponent(qUsers);
    qUsersloginhostname.Name := 'qUsersloginhostname';
    qUsersloginhostname.FieldName := 'loginhostname';
    qUsersloginhostname.Size := 45;
    qUsersloginwebip.SetParentComponent(qUsers);
    qUsersloginwebip.Name := 'qUsersloginwebip';
    qUsersloginwebip.FieldName := 'loginwebip';
    qUsersloginwebip.Size := 45;
    qUserscellnumber.SetParentComponent(qUsers);
    qUserscellnumber.Name := 'qUserscellnumber';
    qUserscellnumber.FieldName := 'cellnumber';
    qUserscellnumber.Size := 45;
    qUsersmailclient.SetParentComponent(qUsers);
    qUsersmailclient.Name := 'qUsersmailclient';
    qUsersmailclient.FieldName := 'mailclient';
    qUserssmsonly.SetParentComponent(qUsers);
    qUserssmsonly.Name := 'qUserssmsonly';
    qUserssmsonly.FieldName := 'smsonly';
    qUserssmsonly.Size := 1;
    qUserspasswordlastchanged.SetParentComponent(qUsers);
    qUserspasswordlastchanged.Name := 'qUserspasswordlastchanged';
    qUserspasswordlastchanged.FieldName := 'passwordlastchanged';
    qUserssmsdieselerrors.SetParentComponent(qUsers);
    qUserssmsdieselerrors.Name := 'qUserssmsdieselerrors';
    qUserssmsdieselerrors.FieldName := 'smsdieselerrors';
    qUserssmsdieselerrors.Size := 1;
    qUserssuspended.SetParentComponent(qUsers);
    qUserssuspended.Name := 'qUserssuspended';
    qUserssuspended.FieldName := 'suspended';
    dsUsers.SetParentComponent(Self);
    dsUsers.Name := 'dsUsers';
    dsUsers.DataSet := qUsers;
    dsUsers.Left := 137;
    dsUsers.Top := 34;
  finally
    WebPanel1.AfterLoadDFMValues;
    WebLabel8.AfterLoadDFMValues;
    WebPanel2.AfterLoadDFMValues;
    WebLabel1.AfterLoadDFMValues;
    wdblUsers.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    btnClose.AfterLoadDFMValues;
    btnCopyRights.AfterLoadDFMValues;
    qUsers.AfterLoadDFMValues;
    qUsersSLNCODE.AfterLoadDFMValues;
    qUsersEMAIL.AfterLoadDFMValues;
    qUsersSLNNAME.AfterLoadDFMValues;
    qUsersSIGNATURE.AfterLoadDFMValues;
    qUsersPASSWORD.AfterLoadDFMValues;
    qUsersACCESSRIGHTS.AfterLoadDFMValues;
    qUsersEMAILPASSWORD.AfterLoadDFMValues;
    qUsersSITES.AfterLoadDFMValues;
    qUsersUSERID.AfterLoadDFMValues;
    qUsersREPCODE.AfterLoadDFMValues;
    qUserslastlogindatetime.AfterLoadDFMValues;
    qUsersloginipaddress.AfterLoadDFMValues;
    qUserslogedin.AfterLoadDFMValues;
    qUsersloginhostname.AfterLoadDFMValues;
    qUsersloginwebip.AfterLoadDFMValues;
    qUserscellnumber.AfterLoadDFMValues;
    qUsersmailclient.AfterLoadDFMValues;
    qUserssmsonly.AfterLoadDFMValues;
    qUserspasswordlastchanged.AfterLoadDFMValues;
    qUserssmsdieselerrors.AfterLoadDFMValues;
    qUserssuspended.AfterLoadDFMValues;
    dsUsers.AfterLoadDFMValues;
  end;
end;

end.
